import {
  Component,
  EventEmitter,
  Input,
  OnChanges, OnDestroy,
  OnInit, Optional,
  Output, QueryList, SimpleChanges, ViewChild, ViewChildren,
} from '@angular/core';
import { SurveyService } from '../../../services/surveys.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../services/general/toast.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { OrganizationService } from '../../../services/organization.service';
import { UserService } from '../../../services/user.service';
import { AlertService } from '../../../services/general/alert.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalShowSurveysComponent } from '../../../modals/modal-show-surveys/modal-show-surveys.component';
import { CkmService } from '../../../services/ckm.service';
import { ModalSurveyDetailsComponent } from '../../../modals/modal-survey-details/modal-survey-details.component';
import { ModalShareQrComponent } from '../../../modals/modal-share-qr/modal-share-qr.component';
import { SingleQuestionComponent } from '../single-question/single-question.component';
import { HeaderTitleService } from '../../../services/general/header-title.service';
import { faLock, faGlobe, faCheckCircle, faInfoCircle, faClipboardList, faSlidersH, faUsers } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-survey-details',
  templateUrl: './survey-details.component.html',
  styleUrls: ['./survey-details.component.scss'],
  standalone: false
})
export class SurveyDetailsComponent implements OnInit, OnDestroy {
  @ViewChildren(SingleQuestionComponent) questionComponents!: QueryList<SingleQuestionComponent>;
  @Input() projectId: any;
  @Input() surveyId: any;
  @Input() surveyObj: any;
  @Input() isResponse = false;
  @Input() noButtons = false;
  @Input() ckmMapID = null;
  @Output() surveyAdded = new EventEmitter();
  @Output() canceled = new EventEmitter();
  @Output() surveyChanged = new EventEmitter();
  @ViewChild('form') form!: NgForm;

  constructor(
    public surveyService: SurveyService,
    public translateService: TranslateService,
    public toast: ToastService,
    public route: ActivatedRoute,
    public organizationService: OrganizationService,
    public userService: UserService,
    public alert: AlertService,
    public router: Router,
    public dialog: MatDialog,
    public ckmService: CkmService,
    private headerTitleService: HeaderTitleService,
    @Optional() private dialogRef: MatDialogRef<SurveyDetailsComponent>
  ) {
  }

  faLock = faLock;
  faGlobe = faGlobe;
  loading = false;
  createMode = true;
  survey = {
    id: null,
    title: '',
    description: '',
    edit_after_submit: false,
    multiple_user_responses_is_enabled: false,
    visibility_type: 'PRIVATE',
    attachments_enabled: true,
    questions: [],
    members: [],
    attachments: [],
    email_template_id: null,
    is_draft: false,
    organization_project_id: null,
    answered: false,
    ckm_map_id: null,
    customs: {
      draft_answer_is_enabled: false,
      anonymous_survey: false,
      anagraphic_is_mandatory: false,
      anagraphic_position: 'START',
      skip_introduction: false
    },
    typeSubmitted: null,
    is_edited_on_revision: false,
    statement_number: null,
    updated_at: null as string | null,
  };
  sections = null;
  questions_filters = {
    selected_section: null,
    only_not_answered: false,
    accordions_opened: true,
  };
  previewMode = false;
  email_templates = [];
  private questionIdCounter = 1;
  private memberIdCounter = 1;
  preSurvey = null;
  _intervalId = null;
  autoSaveLoading = false;
  faCheckCircle = faCheckCircle;
  faInfoCircle = faInfoCircle;
  faClipboardList = faClipboardList;
  faSlidersH = faSlidersH;
  faUsers = faUsers;

  // Survey-level attachments analysis
  showSurveyAttachments = false;
  loadingSurveyAttachments = false;
  surveyProcessedAttachments: any[] = [];
  expandedSurveyAttachmentId: number | null = null;
  surveyAttachmentColumns: string[] = ['name', 'type', 'level', 'status', 'date', 'analysis'];
  hasSurveyAttachmentsFlag = false;

  ngOnInit(): void {
    this.init();
    // setTimeout(() => {
    //   this._intervalId = setInterval(() => {
    //     if (this.createMode && this.hasDifferences() && !this.dialogRef && !this.loading && !this.autoSaveLoading) {
    //       this.onSubmit(
    //         this.form,
    //         this.surveyService.surveySubmittedTypologies.IS_NEW_DRAFT,
    //         true
    //       );
    //     }
    //   }, 10000);
    // }, 10000);
  }

  ngOnDestroy(): void {
    if (this._intervalId) {
      clearInterval(this._intervalId);
    }
  }

  init() {
    this.getSections();
    if (this.userService?.currentOrganization?.id && this.userService.userDetails) {
      this.organizationService.allOrganizationTemplatesEmail(this.userService?.currentOrganization?.id, (data) => {
        this.email_templates = data;
      });
    }

    this.survey.ckm_map_id = this.ckmMapID;

    if (this.isResponse) {
      this.createMode = false;
    }

    if (this.surveyObj) {
      this.survey = this.surveyObj;
      return;
    }

    if (!this.projectId) {
      this.canceled.emit();
    }

    if (this.surveyId) {
      this.createMode = false;
      this.getSurvey();
      this.checkIfHasSurveyAttachments();
    } else {
      if (this.ckmMapID) {
        this.loading = true;
        this.ckmService.getCkmMapSurveyQuestions(this.ckmMapID, (response) => {
          response?.forEach((question) => {


            let min = null;
            let max = null;
            if (question?.ckm_entity_type === 'event') {
              min = 0;
              max = 100;
            } else if (question?.ckm_entity_type === 'action') {
              min = 1;
              max = 5;
            } else {
              min = 0;
              max = 5;
            }

            const obj = {
              id: this.questionIdCounter++,
              question: question?.question,
              required: true,
              typology: this.surveyService.questionTypologies[1].id,
              choices: [],
              description: '',
              attachments: [],
              response: {
                customs: {},
                attachments: [],
              },
              customs: {
                feedback_is_mandatory: false,
                use_description: false,
                use_slider: false,
                tricolor: false,
                min,
                max,
                step: 0.1,
                measure_unit: question?.ckm_entity_type == 'event' ? 'PERCENTAGE' : 'POINT',
                section: this.formatString(question?.ckm_entity_type),
                use_custom_min_max_labels: false,
                ckm_entity_type: question?.ckm_entity_type,
                ckm_entity_id: question?.ckm_entity_id
              }
            };
            this.addQuestion(obj);
          });
          this.loading = false;
        }, (error) => {
          this.loading = false;
        });
      } else {
        this.addQuestion();
      }
      this.survey.members.push({
        id: this.memberIdCounter++,
        name: '',
        last_name: '',
        email: '',
        role: '',
        is_respondent: true
      });
      Promise.resolve().then(() => this.surveyChanged.emit(this.survey));
      this.preSurvey = JSON.parse(JSON.stringify(this.survey));
    }
  }

  openSurveyImportModal() {
    const dialogRef = this.dialog.open(ModalShowSurveysComponent, {
      panelClass: 'medium-dialog',
      data: {
        project_id: this.projectId
      }
    });
    dialogRef.afterClosed().subscribe(event => {
      if (event) {
        const survey = { ...event };
        this.surveyId = survey.id;
        this.getSurvey(true);
      }
    });
  }

  handleSurveyChanged() {
    Promise.resolve().then(() => this.surveyChanged.emit(this.survey));
  }

  getSurvey(isImport = false) {
    this.loading = true;
    this.surveyService.surveyDetails(this.surveyId, (result) => {
      this.survey = result;
      this.preSurvey = JSON.parse(JSON.stringify(this.survey));
      const maxQuestionId = result.questions?.reduce((maxId, question) => {
        return Math.max(maxId, question.id);
      }, 1);
      this.questionIdCounter = maxQuestionId + 1;
      Promise.resolve().then(() => this.surveyChanged.emit(this.survey));
      if (result?.is_draft) {
        this.createMode = true;
      }
      this.loading = false;
      if (isImport) {
        this.survey.id = null;
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('modals.modal-survey-details.survey-cloned-successfully')
        );
      }
      this.preSurvey = JSON.parse(JSON.stringify(this.survey));
      this.headerTitleService.setTitle(result.title);
    }, () => {
      this.loading = false;
    });
  }

  getLastSavedLabel(): string {
    const updatedAt = this.survey?.updated_at;
    if (!updatedAt) {
      return '';
    }
    const updated = new Date(updatedAt).getTime();
    const now = Date.now();
    const diffSeconds = Math.floor((now - updated) / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffSeconds < 60) {
      return `Salvato automaticamente ${diffSeconds} sec fa`;
    }
    if (diffMinutes < 60) {
      return `Salvato automaticamente ${diffMinutes} min fa`;
    }
    if (diffHours < 24) {
      const ore = diffHours === 1 ? 'ora' : 'ore';
      return `Salvato automaticamente ${diffHours} ${ore} fa`;
    }
    const giorni = diffDays === 1 ? 'giorno' : 'giorni';
    return `Salvato automaticamente ${diffDays} ${giorni} fa`;
  }

  get surveyIsPrivate() {
    return this.survey.visibility_type === 'PRIVATE';
  }

  get membersAreValid() {
    if (this.surveyIsPrivate) {
      return !(this.survey.members.length === 0 || this.survey.members.some((member) => !member.name || !member.email));
    }
    return true;
  }

  surveyIsValid() {
    const status = this.surveyService.surveyIsValid(this.survey);
    // @ts-ignore
    if (!status?.valid) {
      // @ts-ignore
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant(status?.message));
      return false;
    }

    return true;
  }

  onSubmit(form: NgForm = null, typeSubmitted: string = this.surveyService.surveySubmittedTypologies.IS_NEW, autoSave = false) {
    const projectId = this.projectId || this.survey.organization_project_id;
    this.autoSaveLoading = autoSave;
    this.loading = true;
    this.survey.typeSubmitted = typeSubmitted;

    // Clear members array for public surveys
    if (this.survey.visibility_type === 'PUBLIC') {
      this.survey.members = [];
    }

    this.checkEditedStatusForAll();

    this.survey.is_edited_on_revision =
      this.survey?.questions?.some((question) => question.is_edited_on_revision || question?.is_new);

    if (typeSubmitted == this.surveyService.surveySubmittedTypologies.IS_NEW_DRAFT) {
      if (typeof this.survey?.title === 'string' && this.survey.title.trim().length > 0) {
        this.survey.is_draft = true;
        this.surveyService.createSurvey(projectId, this.survey, (result) => {
          this.surveyAdded.emit(result);
          this.survey.id = result.id;
          this.surveyId = result.id;
          this.survey?.attachments?.forEach(attachment => {
            if (!attachment?.survey_question_id) {
              attachment.survey_question_id = 'UPLOADED_IN_DRAFT';
            }
          });
          this.survey?.questions?.forEach((q) => {
            q.attachments?.forEach(attachment => {
              if (!attachment?.survey_question_id) {
                attachment.survey_question_id = 'UPLOADED_IN_DRAFT';
              }
            });
          });
          if (autoSave) {
            this.router.navigate(['/surveys', result.id]);
            this.questionComponents?.forEach((component) => {
              component.reset();
            });
            this.preSurvey = JSON.parse(JSON.stringify(this.survey));
          } else {
            this.toast.success(
              this.translateService.instant('generic.success'),
              this.translateService.instant('generic.draft-saved-successfully')
            );
            this.router.navigate(['/']).then(() => {
              this.router.navigate(['/surveys', result.id]);
            });
          }
          this.autoSaveLoading = false;
          this.loading = false;
        }, () => {
          this.loading = false;
          this.autoSaveLoading = false;
        });
      } else {
        this.loading = false;
        this.toast.error(
          this.translateService.instant('generic.warning'),
          this.translateService.instant('modals.modal-survey-details.draft-title-is-mandatory')
        );
      }
    } else {
      this.survey.is_draft = false;

      if (!this.surveyIsValid()) {
        this.loading = false;
        this.survey.is_draft = true;
        return;
      }

      if (!this.membersAreValid) {
        this.toast.error(
          this.translateService.instant('generic.warning'),
          this.translateService.instant('components.decision-table.new-decision-table.compile-proposal.fourth-error')
        );
        this.loading = false;
        this.survey.is_draft = true;
        return;
      }

      if (form && !form.form.valid) {
        this.toast.error(
          this.translateService.instant('generic.warning'),
          this.translateService.instant('pages.surveys.survey-details.not-valid')
        );
        this.loading = false;
        this.survey.is_draft = true;
        return;
      }

      const createSurveyCallback = (result) => {
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('modals.modal-survey-details.survey-created-successfully')
        );
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant('modals.modal-survey-details.survey-team-members-invited')
        );
        this.surveyAdded.emit(result);
        this.survey = result;
        this.preSurvey = JSON.parse(JSON.stringify(this.survey));
        this.loading = false;
        this.router.navigate(['/']).then(() => {
          this.router.navigate(['/surveys', result.id]);
        });
      };

      const handleSurveyCreationFailure = () => {
        this.survey.is_draft = true;
        this.loading = false;
      };

      if (!this.survey.email_template_id && this.surveyService.surveySubmittedTypologies.IS_NEW == this.survey.typeSubmitted) {
        this.alert.showQuestion(
          this.translateService.instant('generic.warning'),
          this.translateService.instant('pages.template.no-selected-template'),
          (ok) => {
            this.surveyService.createSurvey(projectId, this.survey, createSurveyCallback, handleSurveyCreationFailure);
          }, handleSurveyCreationFailure
        );
      } else {
        this.surveyService.createSurvey(projectId, this.survey, createSurveyCallback, handleSurveyCreationFailure);
      }
    }
  }

  deleteSurvey() {
    this.loading = true;
    this.surveyService.deleteSurvey(this.survey.id, (result) => {
      this.loading = false;
      this.canceled.emit(this.survey);
      this.toast.success(
        this.translateService.instant('generic.success'),
        this.translateService.instant('modals.modal-survey-details.survey-deleted-successfully'),
      );
    }, () => {
      this.loading = false;
    });
  }

  drop(event: CdkDragDrop<object[]>) {
    moveItemInArray(this.survey?.questions, event.previousIndex, event.currentIndex);
  }

  addQuestion(question = null) {
    if (question) {
      this.survey.questions?.push({
        ...question,
        id: this.questionIdCounter++,
        is_new: true
      });
    } else {
      this.survey.questions?.push({
        id: this.questionIdCounter++,
        question: 'Question ' + (this.survey?.questions?.length + 1),
        required: true,
        typology: this.surveyService.questionTypologies[0].id,
        choices: [],
        description: '',
        attachments: [],
        response: {
          customs: {},
          attachments: [],
        },
        customs: {
          feedback_is_mandatory: false,
          use_description: false,
          use_slider: false,
          tricolor: false,
          min: null,
          max: null,
          step: 1,
          use_custom_min_max_labels: false,
          use_cascade_select: false
        },
        is_new: true
      });
    }
  }

  getSections() {
    const sections = [{
      id: 'DETAILS',
      title: 'modals.modal-survey-details'
    }];

    if (this.surveyId) {
      sections.push({
        id: 'MEMBERS',
        title: 'generic.team'
      });
    }

    sections.push({
      id: 'QUESTIONS',
      title: 'generic.questions'
    });

    this.sections = sections;
  }

  removeQuestion(id) {
    this.survey.questions = this.survey.questions.filter(question => question.id !== id);
  }

  copyLink() {
    const path = environment.logoutReturnUrl + '#/' + 'surveys/' + this.surveyId + '/response';
    navigator.clipboard.writeText(path);
    this.toast.success(this.translateService.instant('generic.success'), this.translateService.instant('generic.link-copied'));
  }

  openQrDialog() {
    const path = environment.logoutReturnUrl + '#/' + 'surveys/' + this.surveyId + '/response';
    this.dialog.open(ModalShareQrComponent, {
      panelClass: 'medium-dialog',
      data: {
        link: path
      }
    });
  }

  reviewSurvey() {
    this.alert.showQuestion(
      this.translateService.instant('generic.warning'),
      this.translateService.instant('modals.modal-survey-details.new-revision-warning'),
      (ok) => {
        this.onSubmit(null, this.surveyService.surveySubmittedTypologies.IS_NEW_REVISION);
      }, () => {

      }
    );
  }

  startNewSurveySession() {
    this.alert.showQuestion(
      this.translateService.instant('generic.warning'),
      this.translateService.instant('modals.modal-survey-details.new-revision-session-warning'),
      (ok) => {
        this.onSubmit(null, this.surveyService.surveySubmittedTypologies.IS_NEW_SESSION);
      }, () => {

      }
    );
  }

  downloadResponsesCSV() {
    this.loading = true;
    this.surveyService.downloadResponsesCSV(this.survey.id, (response) => {
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  get question_sections() {
    return [...new Set(this.survey?.questions?.map(question => question?.customs?.section))].filter(section => section);
  }

  get filteredQuestions() {
    let questions = this.survey.questions;

    if (this.questions_filters.selected_section) {
      questions = questions.filter(question => question?.customs?.section === this.questions_filters.selected_section);
    }

    if (this.questions_filters.only_not_answered) {
      questions = questions.filter(question => !this.surveyService.surveyQuestionAnswerIsValid(question, false)?.valid);
    }

    return questions;
  }

  enablePreviewMode() {
    this.survey?.questions.forEach(question => {
      if (question?.response === undefined) {
        question.response = {
          customs: {},
        };
      }
    });
    this.isResponse = true;
    this.createMode = false;
    this.previewMode = true;
    this.sections = this.sections.filter(section => section.id !== 'DETAILS');
  }

  disablePreviewMode() {
    this.isResponse = false;
    this.createMode = true;
    this.previewMode = false;
    this.sections.unshift({
      id: 'DETAILS',
      title: 'modals.modal-survey-details'
    });
  }

  get currentUserInTeam() {
    return this.survey?.members?.find((member) => member?.user_id === this.userService.userDetails.user_id);
  }

  formatString(str): void {
    return str
      .replace(/_/g, ' ') // sostituisce tutti gli underscore con spazi
      .split(' ')         // divide la stringa in parole
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // capitalizza ogni parola
      .join(' ');         // ricompone la stringa
  }

  checkEditedStatusForAll(): void {
    this.questionComponents?.forEach((component, index) => {
      component.isEdited();
    });
  }

  hasDifferences(): boolean {
    const ignoredKeys = [];

    const hasDiff = (a: any, b: any): boolean => {
      if (a === b) {
        return false;
      }
      if (a == null || b == null) {
        return a !== b;
      }

      if (typeof a !== typeof b) {
        return true;
      }

      if (typeof a === 'object') {
        const keys = Array.from(
          new Set([
            ...Object.keys(a || {}),
            ...Object.keys(b || {}),
          ])
        ).filter((k) => !ignoredKeys.includes(k));

        for (const key of keys) {
          if (hasDiff(a[key], b[key])) {
            return true;
          }
        }

        return false;
      }

      return a !== b;
    };

    return hasDiff(this.preSurvey, this.survey);
  }

  /**
   * Load all survey-level attachments with LLM analysis
   */
  loadSurveyAttachments(): void {
    if (!this.surveyId) {
      console.error('Missing surveyId');
      return;
    }

    this.loadingSurveyAttachments = true;

    this.surveyService.getAttachmentsLLMAnalysis(
      this.surveyId.toString(),
      '', // No question ID for survey-level
      undefined,
      (result) => {

        // Handle different response formats
        if (Array.isArray(result)) {
          this.surveyProcessedAttachments = result;
        } else if (result && typeof result === 'object') {
          this.surveyProcessedAttachments = result.data || result.attachments || result.results || [];
        } else {
          this.surveyProcessedAttachments = [];
        }

        this.showSurveyAttachments = true;
        this.loadingSurveyAttachments = false;
      },
      (error) => {
        console.error('Error loading survey attachments:', error);
        this.loadingSurveyAttachments = false;
        this.surveyProcessedAttachments = [];
        this.toast.error(
          this.translateService.instant('generic.error'),
          'Failed to load survey attachments'
        );
      }
    );
  }

  /**
   * Toggle survey attachments display
   */
  toggleSurveyAttachments(): void {
    if (this.showSurveyAttachments) {
      this.showSurveyAttachments = false;
      this.expandedSurveyAttachmentId = null;
    } else {
      if (this.surveyProcessedAttachments.length === 0) {
        this.loadSurveyAttachments();
      } else {
        this.showSurveyAttachments = true;
      }
    }
  }

  /**
   * Toggle the expansion of a survey attachment's analysis
   */
  toggleSurveyAttachmentExpansion(attachmentId: number): void {
    if (this.expandedSurveyAttachmentId === attachmentId) {
      this.expandedSurveyAttachmentId = null;
    } else {
      this.expandedSurveyAttachmentId = attachmentId;
    }
  }

  /**
   * Check if survey has attachments by calling the endpoint
   */
  checkIfHasSurveyAttachments(): void {
    if (!this.surveyId) {
      this.hasSurveyAttachmentsFlag = false;
      return;
    }

    this.surveyService.getAttachmentsLLMAnalysis(
      this.surveyId.toString(),
      '', // No question ID for survey-level
      undefined,
      (result) => {
        let attachments: any[] = [];
        if (Array.isArray(result)) {
          attachments = result;
        } else if (result && typeof result === 'object') {
          attachments = result.data || result.attachments || result.results || [];
        }

        this.hasSurveyAttachmentsFlag = attachments.length > 0;
      },
      (error) => {
        console.error('Error checking survey attachments:', error);
        this.hasSurveyAttachmentsFlag = false;
      }
    );
  }

  /**
   * Check if survey has attachments to determine if "View Attachments" button should be displayed
   */
  get hasSurveyAttachments(): boolean {
    return this.hasSurveyAttachmentsFlag;
  }
}
